import { sanitizeHtmlToPlainText } from '$lib/utils';

export type FaqTopicLike = {
	questions?: { question: string; answer: string }[] | null;
};

/**
 * FAQPage schema.org object, or `null` if there are no valid Q&A pairs.
 * @see https://developers.google.com/search/docs/appearance/structured-data/faqpage
 */
export function buildFaqPageSchema(
	topics: FaqTopicLike[] | null | undefined
): Record<string, unknown> | null {
	const mainEntity: object[] = [];
	for (const topic of topics ?? []) {
		for (const q of topic.questions ?? []) {
			const name = sanitizeHtmlToPlainText(q.question);
			const text = sanitizeHtmlToPlainText(q.answer);
			if (!name || !text) {
				continue;
			}
			mainEntity.push({
				'@type': 'Question',
				name,
				acceptedAnswer: {
					'@type': 'Answer',
					text
				}
			});
		}
	}
	if (mainEntity.length === 0) {
		return null;
	}
	return {
		'@context': 'https://schema.org',
		'@type': 'FAQPage',
		mainEntity
	};
}
